<template>
    <svg
        width="90"
        height="90"
        viewBox="0 0 90 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            opacity="0.3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45 81C64.8823 81 81 64.8823 81 45C81 25.1177 64.8823 9 45 9C25.1177 9 9 25.1177 9 45C9 64.8823 25.1177 81 45 81ZM45 85C67.0914 85 85 67.0914 85 45C85 22.9086 67.0914 5 45 5C22.9086 5 5 22.9086 5 45C5 67.0914 22.9086 85 45 85Z"
            fill="#6A7383"
        />
        <g opacity="0.3">
            <path
                d="M45 21C47.2091 21 49 22.7909 49 25V48.5C49 50.7091 47.2091 52.5 45 52.5C42.7909 52.5 41 50.7091 41 48.5V25C41 22.7909 42.7909 21 45 21Z"
                fill="#F45A49"
            />
            <path
                d="M45 60.5C47.2091 60.5 49 62.2909 49 64.5V65C49 67.2091 47.2091 69 45 69C42.7909 69 41 67.2091 41 65V64.5C41 62.2909 42.7909 60.5 45 60.5Z"
                fill="#F45A49"
            />
        </g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45 23C43.8954 23 43 23.8954 43 25V48.5C43 49.6046 43.8954 50.5 45 50.5C46.1046 50.5 47 49.6046 47 48.5V25C47 23.8954 46.1046 23 45 23ZM39 25C39 21.6863 41.6863 19 45 19C48.3137 19 51 21.6863 51 25V48.5C51 51.8137 48.3137 54.5 45 54.5C41.6863 54.5 39 51.8137 39 48.5V25ZM45 62.5C43.8954 62.5 43 63.3954 43 64.5V65C43 66.1046 43.8954 67 45 67C46.1046 67 47 66.1046 47 65V64.5C47 63.3954 46.1046 62.5 45 62.5ZM39 64.5C39 61.1863 41.6863 58.5 45 58.5C48.3137 58.5 51 61.1863 51 64.5V65C51 68.3137 48.3137 71 45 71C41.6863 71 39 68.3137 39 65V64.5Z"
            fill="#F45A49"
        />
    </svg>
</template>
